import { useEffect, useState } from 'react';
import axios from 'axios';
import { getBackendURL } from '../../utils/backendURL';

export default function useOpsUserDetails(id) {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setUser(null);
    setError('');
    axios.get(`${getBackendURL()}/api/ops/users/${encodeURIComponent(id)}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` }, signal: controller.signal,
    }).then(response => { if (!controller.signal.aborted) setUser(response.data); })
      .catch(() => { if (!controller.signal.aborted) setError('Could not load this user. Please retry.'); });
    return () => controller.abort();
  }, [id, attempt]);
  return { user, error, retry: () => setAttempt(value => value + 1) };
}
